/*
* 车辆维修管理组件
* zxw
* 创建时间：
* 修改时间：2026-07-09
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    message,
    Table,
    Select,
    Button,
    Statistic,
    Input,
    Tag,
    Space,
    theme,
} from 'antd';
import { PlusOutlined, ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    isGTscreenWidth,
    GetButtonActionName
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './CarRepairEntity.js';

const MODULENAME = CNF.navItems[1].submenu[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[1].submenu[1].ptn;
const MODULENAME_URL = CNF.navItems[1].submenu[1].url;

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, setOpen, refresh, qss } = props;

    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            fontSize,
            pageSize,
        },
    } = theme.useToken();

    const update = useCallback((record) => {
        setOpen(true, record);
    }, [setOpen]);

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh, update]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );

    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '车牌号码', dataIndex: 'license_number', key: 'license_number', fixed: 'left', width: 120, },
        { title: '维修类型', dataIndex: 'type', key: 'type', },
        { title: '维修明细', dataIndex: 'detail', key: 'detail', },
        { title: '修理厂家', dataIndex: 'repair_factory', key: 'repair_factory', },
        {
            title: '维修费用(元)', key: 'amount',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '40%' : '60%' }} color={colorPrimaryBg}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={record.amount} /></Tag>
        },
        { title: '维修时间', dataIndex: 'time', key: 'time', },
        { title: '申请人', dataIndex: 'apply_displayname', key: 'apply_displayname', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '操作', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetButtonActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation, fontSize, colorPrimary, colorPrimaryBg]);

    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => <Space>
                        总计：<Tag color={colorPrimaryBg}><Statistic precision={CNF.DPL} suffix={qss?.amount > 10000 ? '万元' : '元'} styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={qss?.amount > 10000 ? qss.amount / 10000 : qss.amount} /></Tag>
                        共{pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条
                    </Space>,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
        </>
    );
}

const CarRepair = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [qss, setQss] = useState(null);
    const [carLists, setCarLists] = useState([]);
    const [carUlid, setCarUlid] = useState('');
    const [type, setType] = useState('');
    const [repairFactory, setRepairFactory] = useState('');

    const setOpenModal = useCallback((value, record) => {
        setOpen(value);
        setRecord(record || null);
    }, []);

    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleCarUlidChange = useCallback((value) => {
        setCarUlid(value);
        setCurrentIndex(1);
    }, []);

    const handleTypeChange = useCallback((value) => {
        setType(value);
        setCurrentIndex(1);
    }, []);

    const handleRepairFactoryChange = useCallback((e) => {
        setRepairFactory(e.target.value);
        setCurrentIndex(1);
    }, []);

    useEffect(() => {
        // 获取车辆下拉列表
        const params = {
            rss: 'list',
            page_size: CNF.maxPageSize,
            current_index: 1
        };
        $.ajax({
            url: `${CNF.api}cars${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setCarLists(data.dat || []);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        })
    }, [messageApi]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            car_ulid: carUlid,
            type,
            repair_factory: repairFactory,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
                setQss(data.qss || null);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, carUlid, type, repairFactory]);

    /***
    * 导出为 Excel
    */
    const exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '车辆维修明细-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '车辆维修明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '车牌号码',
                    '维修类型',
                    '维修明细',
                    '修理厂家',
                    '维修费用',
                    '维修时间',
                    '故障原因',
                    '故障描述',
                    '申请人'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出数据
     */
    const exportGetData = () => {

        let params = {
            page_size: CNF.maxPageSize,
            current_index: 1,
            car_ulid: carUlid,
            type,
            repair_factory: repairFactory,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                if (data.dat.length > 0) {
                    //  删除非必须字段
                    var d = [];
                    for (let i = 0; i < data.dat.length; i++) {
                        var item = data.dat[i]
                        delete item['key'];
                        delete item['car_ulid'];
                        // delete item['status'];
                        delete item['apply_username']
                        delete item['create_username']
                        delete item['create_displayname']
                        delete item['create_time']
                        delete item['update_time']
                        d.push(item);
                    }
                    exportAsExcel(d);
                } else {
                    exportAsExcel([]);
                }
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        })
    }

    // 按钮权限判断
    const hasCreate = btnLists.includes(MODULENAME_PTN + '_create');
    const hasExport = btnLists.includes(MODULENAME_PTN + '_export');

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Select
                    showSearch
                    allowClear
                    style={{ width: '100%' }}
                    placeholder='请选择车辆'
                    onChange={handleCarUlidChange}
                    filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                    options={carLists && carLists.map((item, index) => ({
                        key: index,
                        value: item.key,
                        label: item.license_number,
                    }))}
                />
                <Select
                    allowClear
                    style={{ width: '100%' }}
                    placeholder='请选择维修类型'
                    onChange={handleTypeChange}
                    options={CNF.repairTypes && CNF.repairTypes.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key,
                    }))}
                />
                <Input
                    placeholder='修理厂家'
                    value={repairFactory}
                    onChange={handleRepairFactoryChange}
                />
                {hasCreate && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={() => {
                            create();
                        }}>
                        {CNF.actionName.CREATE}
                    </Button>
                )}
                {hasExport && (
                    <Button
                        title={CNF.actionName.EXPORT + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<ExportOutlined />}
                        onClick={() => {
                            exportGetData();
                        }}>
                        {CNF.actionName.EXPORT}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
                qss={qss}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
                carLists={carLists}
            />
        </>
    );
}

export default CarRepair